module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-01-116ca41d5c2bdcfc974429ed79884afa.svg";